import { GameKey } from "../../../defines/GameKey";
import { ceil, max } from "../../../utils/math";
import type { IUIKeyEvent } from "../../IUIKeyEvent";
import { GamePrepareLogic } from "../GamePrepareLogic";
import type { CharMenuLogic } from "./CharMenuLogic";
import { CharMenuState } from "./CharMenuState";
import { CharMenuState_Base } from "./CharMenuState_Base";

export class CharMenuState_CountingDown extends CharMenuState_Base {
  private _count_down: number = 5000;
  constructor(owner: CharMenuLogic) {
    super(CharMenuState.CountingDown, owner);
  }
  override enter() {
    this._count_down = 5000;
  }
  override on_key_down(e: IUIKeyEvent): void {
    const player = this.lfw.players.get(e.player);
    // 生存排行：按“防御”取消倒计时，退回选角
    const survival = this.owner.node.root.search_component(GamePrepareLogic)?.auto_start_when_ready
    if (survival && e.game_key === GameKey.d && player && this.owner.players.has(player)) {
      this.owner.cancel_counting_down(player);
      return;
    }
    this._count_down = max(0, this._count_down - 500);
    if (this.owner.max_player <= this.owner.players.size) return;
    if (!player || e.game_key !== GameKey.a || this.owner.players.has(player)) return;
    this.owner.press_a(player);
    this.owner.fsm.use(CharMenuState.PlayerSel);
  }
  override update(dt: number) {
    this._count_down = max(0, this._count_down - dt);
    const num = ceil(this._count_down / 1000);
    this.owner.slots.forEach(v => v.head?.count_down(num));
    if (num > 0) return;
    // 生存排行（无设置菜单）：就绪后直接开始，并回到选角态（避免返回时自动连开）
    const gpl = this.owner.node.root.search_component(GamePrepareLogic)
    if (gpl?.auto_start_when_ready && this.owner.max_player <= this.owner.players.size) {
      this.lfw.broadcast('start_game')
      this.owner.reset()
      return;
    }
    return this.owner.max_player <= this.owner.players.size ?
      CharMenuState.GameSetting :
      CharMenuState.ComNumSel;
  }
  override leave(): void {
    this.owner.slots.forEach(v => v.head?.count_down(0));
  }
}
